import { t } from "@lingui/macro";
import React from "react";
import { DestinationMenuEntry } from "~/applications/OfferSearch/Domain/DestinationPage";
import Menu, {
  useMenuState,
} from "~/applications/OfferSearch/Ui/StayRequestForm/Menu";
import DestinationSelector from "~/applications/OfferSearch/Ui/StayRequestForm/Selector/DestinationSelector";
import TextualTrigger from "~/applications/OfferSearch/Ui/StayRequestForm/Trigger/TextualTrigger";

const DestinationWithTextualTrigger = ({
  destination,
  destinations,
  onDestinationChange,
}: {
  destination: DestinationMenuEntry | undefined;
  destinations: Array<DestinationMenuEntry>;
  onDestinationChange: (newDestination: DestinationMenuEntry) => void;
}) => {
  const state = useMenuState();

  return (
    <Menu
      state={state}
      title={t`Select a destination`}
      triggerButtonRender={(triggerButtonProps, triggerButtonRef) => (
        <TextualTrigger {...triggerButtonProps} ref={triggerButtonRef}>
          {destination?.name ?? t`Destination`}
        </TextualTrigger>
      )}
    >
      <DestinationSelector
        destinations={destinations}
        selectedDestination={destination}
        onChange={(newDestinationId: DestinationMenuEntry) => {
          onDestinationChange(newDestinationId);
          state.close();
        }}
      />
    </Menu>
  );
};

export default DestinationWithTextualTrigger;
